@let view = vm();
<jui-image-capture
  [images]="view.images"
  [maximages]="1"
  [dataqastring]="view.key"
  (juiImagesChange)="onImagesChange($event)"
  (juiReject)="onReject($event)"
  (juiCaptureRequest)="onCaptureRequest($event)"
></jui-image-capture>
<question-example-images [examples]="view.examples" [key]="view.key"></question-example-images>
@if (view.rejection) {
  <p class="ocr-capture__rejection" role="alert" [attr.data-qa]="view.key + '_rejection'">{{ view.rejection }}</p>
}
<ngx-spinner [name]="spinnerName()" bdColor="rgba(51, 51, 51, 0.8)" size="large" type="line-scale"></ngx-spinner>
